/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Action_JoinInputs */



/**

* @param {Footer_Action_JoinInputs} inputs
* @param {{ locale?: "es" }} options
* @returns {LocalizedString}
*/
export const footer_action_join = /** @type {((inputs?: Footer_Action_JoinInputs, options?: { locale?: "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Action_JoinInputs, { locale?: "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Únete a PauseAI")
});